import { Activityeditor } from '@linktivity/gds-neo';
import config from '../config';

const taskApi = new Activityeditor.TaskApi(config);

export default taskApi;
